import { IconType } from '@aibees/shared/components';
import { PopoverType } from '@aibees/shared/components/custom-popover/use-popover';
import { Nullable } from '@aibees/shared/definition';

export interface SearchListCardProps {
  className?: string;
  hasTabs?: boolean;
  title?: HeaderMenuTitle;
  popoverState?: PopoverType;
  onclose?: (state?: boolean) => void;
}

export interface SearchListCardCol<T = any> {
  key: keyof T;
  title?: string;
  render?: (v: any, item: T, index: number) => any;
}

export interface searchListHeaderConfig {
  noHeading?: boolean;
  header?: Nullable<string>;
  icon?: IconType;
  action: {
    title: Nullable<string>;
    path: Nullable<string>;
  };
}

export interface SearchListCardEmpty {
  img: string;
  text: string;
}

export enum SearchListCardGrouping {
  COMPANY = 'COMPANY',
  PERSON = 'PERSON',
  ALL = 'All Types',
}

export enum SearchListCardVisibility {
  ALL = '',
  PRIVATE = 'PRIVATE',
  INTERNAL = 'INTERNAL',
  PUBLIC = 'PUBLIC',
}

export enum HeaderMenuTitle {
  Saved = 'Saved',
  Lists = 'Lists',
  Labels = 'Labels',
  Export = 'Export',
  Enrich = 'Enrich',
}

export enum LabelSearchTableActionType {
  Include = 'Include',
  Exclude = 'Exclude',
  IncludeAnd = 'IncludeAnd',
}
